// @flow
import MockVideoStreamer from '../components/player/VideoStreamer/MockVideoStreamer';
export default MockVideoStreamer;
